import { ColibriTableConfiguration } from "@/core/ColibriTableConfiguration";
import { useEffect, useState } from "react";

export function useColibriTableConfiguration() {
  const [configurations, setConfigurations] = useState({});

  const isValid =
    configurations?.externalId &&
    configurations?.host &&
    configurations?.port &&
    configurations?.user &&
    configurations?.password;

  useEffect(() => {
    const tableConfigurations = ColibriTableConfiguration.fromStorage();

    setConfigurations(tableConfigurations);

    tableConfigurations.addListener(() => {
      const updatedTableConfigurations =
        ColibriTableConfiguration.fromStorage();
      setConfigurations(updatedTableConfigurations);
    });

    return () => tableConfigurations.removeListener();
  }, []);

  const persistConfigurations = () => {
    const tableConfigurations = ColibriTableConfiguration.fromStorage();
    tableConfigurations.update(configurations);
  };

  const updateConfigurations = (newConfigurations) => {
    if (newConfigurations === null) {
      setConfigurations(null);
    } else {
      setConfigurations({
        ...configurations,
        ...newConfigurations,
      });
    }
  };

  return [configurations, updateConfigurations, persistConfigurations, isValid];
}
